import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { projectSelector } from '../reducers/project';
import {
  getDuplicationMode,
  doToggleDuplicationMode
} from '../reducers/app/duplication';

import { getProjectRequest } from './planActions';

import PlanHeaders from './PlanHeaders';

import { MKS_SERVICE } from '../webAPI/configURL';

class PlanHeadersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: {}
    };
  }

  componentDidMount() {
    this.props.getProjectRequest();
  }

  render() {
    const { protocol, domain } = require('Config');
    const { user, duplicationMode, toggleDuplicationMode } = this.props;

    const downloadLink = `${protocol}${domain}${MKS_SERVICE.GET_PROJECT_EXCEL}?project_id=${encodeURIComponent(this.props.project.project_id)}`;
    return (
      <PlanHeaders
        projectName={this.props.project.name}
        downloadLink={downloadLink}
        user={this.props.user}
        duplicationMode={duplicationMode}
        onDuplicationClick={toggleDuplicationMode}
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    project: projectSelector(state),
    user: state.user,
    duplicationMode: getDuplicationMode(state)
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const { projectId } = ownProps.params;
  return {
    getProjectRequest: () => dispatch(getProjectRequest(projectId)),
    toggleDuplicationMode: () => dispatch(doToggleDuplicationMode())
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PlanHeadersContainer)
);



// WEBPACK FOOTER //
// ./src/js/plan/PlanHeadersContainer.js